export default __webpack_public_path__ + "static/media/login-splash-image2.6afb3361.jpg";